export default "__VITE_ASSET___ybLavI$__"